import { render, staticRenderFns } from "./BeforeAndAfter.vue?vue&type=template&id=13d1b480&scoped=true"
import script from "./BeforeAndAfter.vue?vue&type=script&lang=js"
export * from "./BeforeAndAfter.vue?vue&type=script&lang=js"
import style0 from "./BeforeAndAfter.vue?vue&type=style&index=0&id=13d1b480&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1b480",
  null
  
)

export default component.exports